// Currencies on transaction rows. Pure functions only — no component imports.

/** The fields of a transaction row that say what currency it is in. */
export interface CurrencyFields {
  currency?: string | null
  reporting_fx_rate?: number | null
}

/**
 * One of a row's own amounts in the reporting currency (dollars), for adding rows together: the
 * row's `reporting_fx_rate` when it is in another currency, else the amount as is. A non-dollar
 * row whose rate has not been filled yet reads as dollars, as every total did before.
 */
export function to_reporting_amount(row: CurrencyFields, amount: number): number {
  const code = (row.currency || "USD").toUpperCase()
  if (code === "USD" || row.reporting_fx_rate == null) return amount
  return amount * row.reporting_fx_rate
}
